module.exports = __webpack_public_path__ + "img/january-blue.c1de67b4.svg";